import React, { FC, ReactNode } from "react";
import { AuthnClientProvider } from "./authnClientProvider";
import { UPSClientProvider } from "./upsClientProvider";

export const ApolloProvider: FC<{ children: ReactNode }> = ({ children }) => (
  <AuthnClientProvider>
    <UPSClientProvider>{children}</UPSClientProvider>
  </AuthnClientProvider>
);
